import React, { useEffect, useMemo, useState } from 'react';
import { connect } from "react-redux";
import { abmActions } from '../../../redux/actions/abm.actions';
import { useParams } from 'react-router';
import List from './List';

const actions = {
  Edit: "edit",
  Add: "add",
  default: "",
}

const getAction = (action) => actions[action] ? actions[action] : actions.default;

const _Abm = (props) => {
  const { controller, getSchema, schema, config } = props;
  let { action = "List", id = "0" } = useParams();
  const [state, setState] = useState({loaded: false, actionFn: () => {}})

  
  useEffect(()=>{
    console.log("Index load");
  }, [])

  useEffect(()=>{
    if (!schema) 
      getSchema();
  }, [schema])

  useEffect(()=>{
    setState({...state, loaded: true, actionFn: getAction(action)});
  }, [action])

  const columns = useMemo(()=>{
    return config.columnsAsync(schema);
  }, [config.columnsAsync, schema])

  return (
    <>
      {state.loaded && schema &&
        <List {...props} config={{...config, ...schema, columns}} lateralForm={state.actionFn} />
      }
    </>
  );

}

const mapStateToProps = (controller, action) => (state) => {
  //console.log(state.config.controllers)
  return {
    controller,
    auth: state.auth,
    config: state.config.controllers.filter(x => x.name === controller && x.action === action).pop(),
    snack: state.config.snack,
    ...state[controller],
  };
}

const mapDispatchToProps = (controller) => ({
  ...abmActions(controller)
});

/**
 * @param {*} controller string
 * @returns componente conectado a redux
 */
export const Abm = ({controller, action}) => connect(mapStateToProps(controller, action), mapDispatchToProps(controller, action))(_Abm);
